import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }

import {computed, inject, onBeforeMount, onMounted, reactive, ref} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {useStore} from 'vuex';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import FunctionalSkills from '@/common/components/functional-skills/FunctionalSkills.vue';
    import {useRouter} from 'vue-router';
    import {useTranslation} from '@malt/vue3-use';
    import MaltStrategyFunctionalSkillsSide from '@/profile-creation-wizard/components/for-creation/ui/functionalSkills/MaltStrategyFunctionalSkillsSide.vue';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {FunctionalScope, FunctionalSkill} from '@/profile-creation-wizard/types';

    const maxFunctionalSkills = 10;
    const maxGlobalSkills = 35;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MaltStrategyFunctionalSkillsStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();
    const creationForm = ref(store.getters[getters.creationForm]);
    const preferredCategory = ref(store.getters[getters.preferredCategory]);

    const functional = ref<HTMLElement>(null);
    const creationFormValidation = inject(DI.creationFormValidation);
    const functionalSkillsRepository = inject(DI.functionalSkillsRepository);

    const trackingRepository = inject(DI.trackingRepository);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const state = reactive<{availableFunctionalScopes: FunctionalScope[]}>({
        availableFunctionalScopes: [],
    });

    const hasValidFieldPart = computed(() =>
        creationFormValidation!.areGlobalAndFunctionalSkillsValid(creationForm!.value.tags, creationForm!.value.functionalSkills),
    );

    onBeforeMount(async (): Promise<void> => {
        if (window.hj) {
            // Custom event Hotjar
            window.hj('event', 'profile_creation_details_page');
        }
        await loadFunctionalScopes();
    });

    onMounted((): void => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#details-functional-bottom-sheet',
            '',
            functional.value,
            'div.profile-creation-wizard',
        );
    });

    async function loadFunctionalScopes(): Promise<void> {
        if (preferredCategory.value !== null) {
            const [scopes, error] = await functionalSkillsRepository!.listFunctionalScopesByCategory(preferredCategory.value);
            if (scopes && !error) {
                state.availableFunctionalScopes = scopes;
            }
        }
    }

    function goNext(): void {
        trackingRepository?.track('expertise-chosen-skills-strategy', {
            funtionnalSkills: creationForm.value.functionalSkills.length,
            globalSkills: creationForm.value.tags.length,
        });
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    function handleSelectedSkillsChanged(functionalSkills: FunctionalSkill[]) {
        store.commit(mutations.updateFunctionalSkills, functionalSkills);
    }

    function handleGlobalSkillsAdded(globalSkill: Tag) {
        store.commit(mutations.selectTag, globalSkill);
    }

    function handleGlobalSkillsRemoved(globalSkill: Tag) {
        store.commit(mutations.unselectTag, globalSkill);
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": hasValidFieldPart.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "functional",
        ref: functional,
        class: "details-form__item"
      }, [
        _createVNode(StepItemTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.functionalSkills.title')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.functionalSkills.subtitle', maxFunctionalSkills)) + " ", 1),
          _createElementVNode("a", {
            class: "open-bottom-sheet",
            onClick: openBottomSheet
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.functional.skills.title')), 1)
        ]),
        _createVNode(FunctionalSkills, {
          "available-functional-scopes": state.availableFunctionalScopes,
          "selected-skills": creationForm.value.functionalSkills,
          "global-skills": creationForm.value.tags,
          maxFunctionalSkills: maxFunctionalSkills,
          maxGlobalSkills: maxGlobalSkills,
          "onFunctionalSkills:updated": handleSelectedSkillsChanged,
          "onGlobalSkills:added": handleGlobalSkillsAdded,
          "onGlobalSkills:removed": handleGlobalSkillsRemoved
        }, null, 8, ["available-functional-scopes", "selected-skills", "global-skills"])
      ], 512)
    ]),
    "step-side": _withCtx(() => [
      _createVNode(MaltStrategyFunctionalSkillsSide)
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})